<script setup lang="ts">
import { InputSuffixPrefix } from '~/components/ui/input'

withDefaults(defineProps<{
  placeholder?: string
  modelValue?: string
}>(), {
  placeholder: 'Cari artikel bantuan atau topik',
  modelValue: '',
})

defineEmits<{
  'update:modelValue': [value: string]
}>()
</script>

<template>
  <InputSuffixPrefix
    :model-value="modelValue"
    :placeholder="placeholder"
    class="pl-3 h-[37px]"
    @update:model-value="$emit('update:modelValue', String($event))"
  >
    <template #suffix>
      <IconsSearch class="size-4" />
    </template>
  </InputSuffixPrefix>
</template>
